import React from 'react'
import PropTypes from 'prop-types'
import { usePlaceSelectLogic } from './PlaceSelect.logic.js'
import { PlaceSelectView } from './PlaceSelect.view.jsx'

/**
 * PlaceSelect Component (Container)
 * Searchable dropdown for selecting existing places (warehouses, ramps, terminals, pools)
 * Integrated with React Hook Form
 */
export const PlaceSelect = ({
  name,
  control,
  legType,
  marketUid,
  onSelect,
  required = false,
  index,
  lookupBy = 'uid',
}) => {
  const {
    reactSelectOptions,
    reactSelectValue,
    isLoading,
    onChange,
    onInputChange,
    onMenuOpen,
    onMenuClose,
    inputValue,
    controlShouldRenderValue,
    onBlur,
    name: fieldName,
    selectRef,
    error,
    errorMessage,
  } = usePlaceSelectLogic({
    name,
    control,
    legType,
    marketUid,
    onSelect,
    lookupBy,
  })

  return (
    <PlaceSelectView
      reactSelectOptions={reactSelectOptions}
      reactSelectValue={reactSelectValue}
      isLoading={isLoading}
      onChange={onChange}
      onInputChange={onInputChange}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      inputValue={inputValue}
      controlShouldRenderValue={controlShouldRenderValue}
      onBlur={onBlur}
      name={fieldName}
      selectRef={selectRef}
      required={required}
      index={index}
      error={error}
      errorMessage={errorMessage}
    />
  )
}

PlaceSelect.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  legType: PropTypes.oneOf([
    'OutGateEmpty',
    'OutGateLoaded',
    'OutGateBobtail',
    'InGateEmpty',
    'InGateLoaded',
    'InGateBobtail',
    'AtShipper',
    'AtConsignee',
    'AtEquipment',
  ]).isRequired,
  marketUid: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  required: PropTypes.bool,
  index: PropTypes.number,
  lookupBy: PropTypes.oneOf(['uid', 'place_id']),
}
